import { render, staticRenderFns } from "./FormInputGroupButtonAddons.vue?vue&type=template&id=5fcd210e"
import script from "./FormInputGroupButtonAddons.vue?vue&type=script&lang=js"
export * from "./FormInputGroupButtonAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports